import React from "react";
import { Cpu, LayoutDashboard, Activity } from "lucide-react";

const KEY = "nexus_tv_screen";
const OPTS = [
  { id: "a", label: "TV A", sub: "PRESENCE · face, clock, mission, reminders, living", icon: Cpu },
  { id: "b", label: "TV B", sub: "INTEL · news, business, newsroom, globe, intel", icon: LayoutDashboard },
  { id: "floor", label: "FLOOR", sub: "TRADING FLOOR · live agent desks, replay when idle", icon: Activity },
];

export default function TvPicker() {
  let last = null;
  try { last = localStorage.getItem(KEY); } catch (e) {}
  if (window.location.search.includes("scene=")) { window.location.replace(`/tv/b${window.location.search}`); return null; }
  const go = (id) => { try { localStorage.setItem(KEY, id); } catch (e) {} window.location.href = `/tv/${id}`; };
  return (
    <div className="h-screen bg-[#030712] nx-display nx-scanlines flex flex-col items-center justify-center gap-10 p-8" data-testid="tv-picker">
      <p className="nx-orbitron text-4xl font-black tracking-[0.3em] text-[#00F0FF]" style={{ textShadow: "0 0 24px #00F0FF66" }}>WHICH TV IS THIS?</p>
      <div className="grid grid-cols-3 gap-8 w-full max-w-6xl">
        {OPTS.map((o) => (
          <button key={o.id} onClick={() => go(o.id)} data-testid={`tv-picker-${o.id}`}
            className={`nx-glass rounded-3xl p-10 text-left transition-transform hover:scale-[1.03] border-2 ${last === o.id ? "border-[#00F0FF]" : "border-cyan-300/15"}`}>
            <o.icon className="w-10 h-10 text-[#00F0FF] mb-4" />
            <p className="nx-orbitron text-3xl font-black tracking-widest text-cyan-50">{o.label}</p>
            <p className="nx-mono text-sm tracking-widest text-cyan-300/60 mt-2">{o.sub}</p>
            {last === o.id && <p className="nx-mono text-xs tracking-widest text-emerald-300 mt-4" data-testid={`tv-picker-last-${o.id}`}>● LAST USED ON THIS TV</p>}
          </button>
        ))}
      </div>
    </div>
  );
}
